import { render, staticRenderFns } from "./Layout363.vue?vue&type=template&id=52935db2"
import script from "./Layout363.vue?vue&type=script&lang=js"
export * from "./Layout363.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports